"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.EImageProcessScene = void 0;

_Object$defineProperty(exports, "MISSEVAN_API_PREFIX_URL", {
  enumerable: true,
  get: function get() {
    return _url2.MISSEVAN_API_PREFIX_URL;
  }
});

_Object$defineProperty(exports, "MISSEVAN_APP_PREFIX_URL", {
  enumerable: true,
  get: function get() {
    return _url2.MISSEVAN_APP_PREFIX_URL;
  }
});

_Object$defineProperty(exports, "MISSEVAN_APP_SCHEME_PREFIX", {
  enumerable: true,
  get: function get() {
    return _url2.MISSEVAN_APP_SCHEME_PREFIX;
  }
});

_Object$defineProperty(exports, "MISSEVAN_CDN_PREFIX_URL", {
  enumerable: true,
  get: function get() {
    return _url2.MISSEVAN_CDN_PREFIX_URL;
  }
});

_Object$defineProperty(exports, "MISSEVAN_ENV", {
  enumerable: true,
  get: function get() {
    return _url2.MISSEVAN_ENV;
  }
});

_Object$defineProperty(exports, "MISSEVAN_FM_API_PREFIX_URL", {
  enumerable: true,
  get: function get() {
    return _url2.MISSEVAN_FM_API_PREFIX_URL;
  }
});

_Object$defineProperty(exports, "MISSEVAN_LINK_PREFIX_URL", {
  enumerable: true,
  get: function get() {
    return _url2.MISSEVAN_LINK_PREFIX_URL;
  }
});

_Object$defineProperty(exports, "MISSEVAN_MOBILE_API_PREFIX_URL", {
  enumerable: true,
  get: function get() {
    return _url2.MISSEVAN_MOBILE_API_PREFIX_URL;
  }
});

_Object$defineProperty(exports, "MISSEVAN_SITE_MAIN", {
  enumerable: true,
  get: function get() {
    return _url2.MISSEVAN_SITE_MAIN;
  }
});

exports.addUrlProtocol = addUrlProtocol;
exports.ensureHttps = ensureHttps;

_Object$defineProperty(exports, "getMissEvanAPIPrefixURL", {
  enumerable: true,
  get: function get() {
    return _url2.getMissEvanAPIPrefixURL;
  }
});

_Object$defineProperty(exports, "getMissEvanAppPrefixURL", {
  enumerable: true,
  get: function get() {
    return _url2.getMissEvanAppPrefixURL;
  }
});

_Object$defineProperty(exports, "getMissEvanCDNPrefixURL", {
  enumerable: true,
  get: function get() {
    return _url2.getMissEvanCDNPrefixURL;
  }
});

_Object$defineProperty(exports, "getMissEvanFMAPIPrefixURL", {
  enumerable: true,
  get: function get() {
    return _url2.getMissEvanFMAPIPrefixURL;
  }
});

_Object$defineProperty(exports, "getMissEvanLinkPrefixURL", {
  enumerable: true,
  get: function get() {
    return _url2.getMissEvanLinkPrefixURL;
  }
});

_Object$defineProperty(exports, "getMissEvanMobileAPIPrefixURL", {
  enumerable: true,
  get: function get() {
    return _url2.getMissEvanMobileAPIPrefixURL;
  }
});

_Object$defineProperty(exports, "getMissEvanSiteMain", {
  enumerable: true,
  get: function get() {
    return _url2.getMissEvanSiteMain;
  }
});

_Object$defineProperty(exports, "isStaging", {
  enumerable: true,
  get: function get() {
    return _url2.isStaging;
  }
});

_Object$defineProperty(exports, "isUAT", {
  enumerable: true,
  get: function get() {
    return _url2.isUAT;
  }
});

exports.newURL = newURL;
exports.processImageUrl = processImageUrl;
exports.removeUrlProtocol = removeUrlProtocol;
exports.replaceToFreeFlowUrl = replaceToFreeFlowUrl;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));

var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/ends-with"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/starts-with"));

var _mobile = require("./utils/mobile");

var _support = require("./utils/support");

var _url2 = require("./url");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 移除 URL protocol
 *
 * @param url 网页链接
 * @example 'https://example.com/1.jpg' -> '//example.com/1.jpg'
 */
function removeUrlProtocol(url) {
  return url ? url.replace(/^https?:/i, '') : '';
}
/**
 * 添加 URL protocol
 */


function addUrlProtocol(url) {
  return (0, _startsWith.default)(url).call(url, '//') ? "https:".concat(url) : url;
}
/**
 * 确保 URL 使用 HTTPS 协议
 * @param url 传入 URL
 * @example
 *  'http://example.com/1.jpg' -> 'https://example.com/1.jpg'
 *  '//example.com/1.jpg' -> 'https://example.com/1.jpg'
 *  'https://example.com/1.jpg' -> 'https://example.com/1.jpg'
 */


function ensureHttps(url) {
  if ((0, _startsWith.default)(url).call(url, 'https:')) {
    return url;
  }

  if ((0, _startsWith.default)(url).call(url, '//')) {
    return "https:".concat(url);
  }

  return url.replace(/^http:\/\//i, 'https://');
}
/**
 * 封装 URL 构造方法，由于 `new URL()` 失败时会抛出错误，在 react app 中有白屏风险，所以此处使用 catch 处理
 * 业务项目可接入 sentry 监控 `console.error()`，便于修复错误代码或错误数据
 */


function newURL(url) {
  try {
    return new _url.default(ensureHttps(url));
  } catch (error) {
    console.error(error);
    return '';
  }
}

var FREE_FLOW_REPLACE_RULES = [// 静态小文件免流（如图片）
{
  host: 'static.maoercdn.com',
  replace_host: 'static-tf-ali-cdn-cn.maoercdn.com'
}, // 国内音频免流
{
  host: 'sound-ks-cdn-cn.maoercdn.com',
  replace_host: 'sound-tf-ks-cdn-cn.maoercdn.com'
}, {
  host: 'sound-ks1-cdn-cn.maoercdn.com',
  replace_host: 'sound-tf-ks1-cdn-cn.maoercdn.com'
}, // 以下为旧的免流地址
{
  host: 'static.missevan.com',
  replace_host: 'static-tf-ali-cdn-cn.maoercdn.com'
}, {
  host: 'sound-ks1.cdn.missevan.com',
  replace_host: 'sound-tf-ks1-cdn-cn.maoercdn.com'
}, // 用于 UAT 检查链接是否正确替换
{
  host: 'static-test.maoercdn.com',
  replace_host: 'static-test.missevan.com'
}];
/**
 * 在 APP 开启免流后，将符合免流规则的链接的域名替换为对应的免流专属域名
 * 返回的链接会自动移除链接中的 protocol，无论它是否符合免流要求
 *
 * @param url 原始资源链接
 */

function replaceToFreeFlowUrl(url) {
  var impl = function impl() {
    var _getAppInfo;

    if (!url || !((_getAppInfo = (0, _mobile.getAppInfo)()) !== null && _getAppInfo !== void 0 && _getAppInfo.freeFlow)) {
      return url;
    }

    var formattedUrl = addUrlProtocol(url);

    try {
      var parsedUrl = new _url.default(formattedUrl);
      var rule = (0, _find.default)(FREE_FLOW_REPLACE_RULES).call(FREE_FLOW_REPLACE_RULES, function (v) {
        return v.host === parsedUrl.host;
      });

      if (!rule) {
        return url;
      }

      parsedUrl.host = rule.replace_host;
      return parsedUrl.toString();
    } catch (e) {
      return url;
    }
  };

  return ensureHttps(impl());
}

var EImageProcessScene; // B站图片缩放规则文档请戳：https://info.bilibili.co/pages/viewpage.action?pageId=59399366
// url = '//s1.hdslb.com/bfs/maoer/avatars/icon01.png@.webp' // 可以用这个 bfs 图片测试

exports.EImageProcessScene = EImageProcessScene;

(function (EImageProcessScene) {
  EImageProcessScene["Avatar"] = "avatar";
  EImageProcessScene["Playbar"] = "playbar";
  EImageProcessScene["Playlist"] = "playlist";
})(EImageProcessScene || (exports.EImageProcessScene = EImageProcessScene = {}));

function processBFSImage(pathname, scene) {
  var newPathname = pathname;
  var pathnameMatch = newPathname.match(/\.(webp|jpg|jpeg|png|gif)($|@)/i);

  if (!pathnameMatch) {
    return newPathname;
  } // pathnameMatch[1] 是原图格式, pathnameMatch[2] 经过 bfs 处理过的图片


  var imgType = pathnameMatch[1].toLowerCase();
  var isProcessed = !!pathnameMatch[2]; // 已经经过 bfs 处理的图片

  if (isProcessed) {
    return newPathname;
  }

  var isWebp = imgType === 'webp';
  var isAvatar = scene === EImageProcessScene.Avatar; // 未经过 bfs 处理的非头像 webp

  if (isWebp && !isAvatar) {
    return newPathname;
  }

  var bfsParams = '';

  if (isAvatar) {
    bfsParams = '320w_320h_1c';
  } // 判断浏览器是否支持 webp：动图需支持 animation，其他格式需支持 alpha


  var isGif = imgType === 'gif';

  if (!isWebp && (isGif && _support.Supports.WebPAnimation || _support.Supports.WebPAlpha)) {
    bfsParams += '.webp';
  }

  if (bfsParams) {
    newPathname += "@".concat(bfsParams);
  }

  return newPathname;
}

function processMaoerImage(url, scene) {
  // 如果 url 携带 x-oss-process 参数，应视为 url 已经被处理过，不需要再添加其他参数
  if (url.match(/\?x-oss-process=/)) {
    return url;
  }

  var newUrl = url;

  if (scene === EImageProcessScene.Avatar) {
    newUrl += _support.Supports.WebPAlpha ? '?x-oss-process=style/avatar' : '?x-oss-process=style/avatar_jpg';
  } else if (scene === EImageProcessScene.Playbar) {
    newUrl += '?x-oss-process=style/playbar';
  } else if (scene === EImageProcessScene.Playlist) {
    newUrl += '?x-oss-process=style/playlist';
  } else if ((0, _endsWith.default)(newUrl).call(newUrl, '.gif')) {
    // general
    // animation
    if (_support.Supports.WebPAnimation) {
      newUrl += '?x-oss-process=style/webp';
    }
  } else if (_support.Supports.WebPAlpha) {
    // 原图已经过 image 处理，但未经过 webp 处理，则添加 webp 格式转换处理
    if (newUrl.match(/\?x-oss-process=image/) && !newUrl.match(/format,webp/)) {
      newUrl += '/format,webp';
    } else if (!(0, _endsWith.default)(url).call(url, '.webp') && !(0, _endsWith.default)(url).call(url, '.svg') && !(0, _endsWith.default)(url).call(url, '.avif') && !newUrl.match(/\?x-oss-process/)) {
      // 原图未经过任何处理
      newUrl += '?x-oss-process=style/webp';
    }
  }

  return newUrl;
}
/**
 * 处理 BFS 和猫耳的图片链接。可去除协议头、增加图片参数、替换免流链接。
 * 由于本函数依赖 Supports 做兼容处理，需要提前执行初始化操作。
 * @example
 *   await Supports.init()
 *   processImageUrl(url)
 */


function processImageUrl(url, scene) {
  var _context;

  var imgUrl = newURL(url);

  if (!imgUrl) {
    return imgUrl;
  }

  var isMaoerCDN = /^((static|static-test)\.(missevan|maoercdn)\.com)$/.test(imgUrl.host);
  var isBFS = (0, _indexOf.default)(url).call(url, '/bfs/') !== -1; // 外部图片不需要进行图片处理

  if (!isMaoerCDN && !isBFS) {
    return url;
  }

  var newUrl = isBFS ? (0, _concat.default)(_context = "//".concat(imgUrl.host)).call(_context, processBFSImage(imgUrl.pathname, scene)) : processMaoerImage(url, scene);
  return replaceToFreeFlowUrl(newUrl);
}